// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__2l-A7","image":"recipe_image__2JMIE"};